// Types for AGG graphQL queries are NOT autogenerated in CFE
// This file was manually created
export var QuickFindAllActivityDataEdgeNodeObjectProduct = /*#__PURE__*/function (QuickFindAllActivityDataEdgeNodeObjectProduct) {
  QuickFindAllActivityDataEdgeNodeObjectProduct["JIRA"] = "jira";
  QuickFindAllActivityDataEdgeNodeObjectProduct["CONFLUENCE"] = "confluence";
  QuickFindAllActivityDataEdgeNodeObjectProduct["ATLAS"] = "townsquare";
  return QuickFindAllActivityDataEdgeNodeObjectProduct;
}({});
export var VIEWED_EVENT = /*#__PURE__*/function (VIEWED_EVENT) {
  VIEWED_EVENT["VIEWED"] = "viewed";
  return VIEWED_EVENT;
}({});
export var WORKED_EVENT = /*#__PURE__*/function (WORKED_EVENT) {
  WORKED_EVENT["COMMENTED"] = "commented";
  WORKED_EVENT["CREATED"] = "created";
  WORKED_EVENT["EDITED"] = "edited";
  WORKED_EVENT["PUBLISHED"] = "published";
  WORKED_EVENT["UPDATED"] = "updated";
  return WORKED_EVENT;
}({});